import React from 'react';
import styled from 'styled-components';

import { Button, Modal } from '@common/index';
import { alpha, Stack } from '@mui/material';
import { useTheme } from '../../../styles';
import { Loader } from '@common/hooks/useLoader';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1rem;
`;

interface Props {
  header: string;
  icon: React.ReactNode;
  loading: boolean;
  setOpen: React.Dispatch<React.SetStateAction<string | null>>;
}

export const LoaderLoading: React.FC<Props> = ({ header, icon, loading, setOpen }) => {
  const theme = useTheme();

  return (
    <Modal
      open={loading}
      setOpen={() => setOpen(null)}
      info='The loader is currently running. Please wait for it to complete.'
      background={alpha(theme.text.standard, 0.06)}
      header={header}
      icon={icon}
      body={
        <Container>
          <Loader />
        </Container>
      }
      actions={
        <Stack spacing={1} direction='row'>
          <Button onClick={() => setOpen(null)}>Close</Button>
        </Stack>
      }
    />
  );
};
